import { Props_SnippetContent } from './Content.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetContent = (props: Props_SnippetContent) => {
    const { heading, content } = props
    
    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-content__heading--${heading.visibility.value}` : ''

    return (
        <section className="snippet-content">
            <div className="snippet-content__container">
                <h2 className={`snippet-content__heading ${classHeadingVisibility}`}>{heading.content?.value}</h2>
                { content.content?.value && <div className="snippet-content__content">{ Legacy_CompileMarkdown(content.content.value) }</div> }
            </div>
        </section>
    )}

export default SnippetContent
